// Pure rules of the Nhật ký bot screen. They mirror the backend rules in
// app/services/reply_ratings.py; the backend still decides.

export const SENTIMENTS = ['positive', 'neutral', 'negative']
export const REVIEW_FILTERS = ['all', 'unrated', 'right', 'wrong']

// Why a rating cannot be saved yet, or null. A wrong verdict needs the answer that
// should have been given and the FAQ question it belongs to.
export function ratingProblem({ verdict, comment, question }) {
  if (verdict !== 'wrong') return null
  if (!comment?.trim()) return 'comment_required'
  if (!question?.trim()) return 'question_required'
  return null
}

// The next row id when moving the selection by `delta` (+1 down, -1 up), clamped to the list.
export function moveSelection(rows, selectedId, delta) {
  if (rows.length === 0) return null
  const index = rows.findIndex((row) => row.id === selectedId)
  if (index < 0) return rows[0].id
  const next = Math.min(Math.max(index + delta, 0), rows.length - 1)
  return rows[next].id
}

// The sentiment a row shows. Null means no label was produced.
export function shownSentiment(row) {
  return row.sentiment ?? null
}

// True when the key event comes from a field, so arrow keys must not move the selection.
export function isTypingTarget(target) {
  if (!target) return false
  const tag = target.tagName
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target.isContentEditable === true
}
